import type { FC, ReactNode } from "react";
import styled, { css } from "styled-components";
import {
  ItemText,
  focusVisible,
} from "../../NavigationBar/SidebarItemElements";

import { ProfileItemButtonContainer } from "./ProfileElements";

const StyledButton = styled.button<{
  isActive: boolean;
  withSpacing: boolean;
}>`
  all: initial;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  flex: 1;
  gap: 10px;
  color: ${({ isActive }) =>
    isActive
      ? "var(--sinch-comp-color-menu-option-color-default-border-selected)"
      : "var(--sinch-comp-color-menu-option-color-default-border-active)"};

  :hover {
    color: var(--sinch-comp-color-menu-option-color-default-border-active);
  }
  ${({ withSpacing }) =>
    withSpacing &&
    css`
      padding: 0 0 0 16px;
    `}
  ${focusVisible("0px")}
`;

const StyledItemText = styled(ItemText)<{ withSpacing: boolean }>`
  ${({ withSpacing }) =>
    withSpacing &&
    css`
      margin: 0;
    `}
`;

type ProfileListButtonProps = {
  text: string;
  icon?: ReactNode;
  withSpacing?: boolean;
  onClick: () => void;
};
export const ProfileListButton: FC<ProfileListButtonProps> = ({
  text,
  icon,
  withSpacing = false,
  onClick,
}) => (
  <ProfileItemButtonContainer isActive={false}>
    <StyledButton onClick={onClick} isActive={false} withSpacing={withSpacing}>
      {icon}
      <StyledItemText withSpacing={withSpacing}>{text}</StyledItemText>
    </StyledButton>
  </ProfileItemButtonContainer>
);
